var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"53fbc5e4897b2d2a57a1414561fceaf9a8c7c8d8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-frontend@linkgraph"]={id:"53fbc5e4897b2d2a57a1414561fceaf9a8c7c8d8"};
      